import { defineMessages } from 'react-intl';

export default defineMessages({
  perGuest: {
    id: 'experienceSummary.people.perGuest',
    defaultMessage: 'per guest',
  },
  perGroup: {
    id: 'experienceSummary.people.perGroup',
    defaultMessage: 'per group',
  },
  forGuests: {
    id: 'experienceSummary.people.forGuests',
    defaultMessage: 'for {count} guests',
  },
  from: {
    id: 'experienceSummary.people.from',
    defaultMessage: 'from {count} guests',
  },
  to: {
    id: 'experienceSummary.people.to',
    defaultMessage: 'up to {count} guests',
  },
  same: {
    id: 'experienceSummary.people.same',
    defaultMessage: '{count, plural, one {1 guest} other {{count} guests}}',
  },
  fromTo: {
    id: 'experienceSummary.people.fromTo',
    defaultMessage: '{from}-{to} guests',
  },
});
